import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConsultationModal } from '../context/ConsultationModalContext';
import Layout from '../components/Layout';
import { useTheme } from '../context/ThemeContext';
import { Loader2 } from 'lucide-react';

const DemoRequest = () => {
    const { openModal } = useConsultationModal();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const isDarkMode = theme === 'dark';

    useEffect(() => {
        // Small delay to ensure the page renders, then open the modal
        const timer = setTimeout(() => {
            openModal();
        }, 500);

        return () => clearTimeout(timer);
    }, [openModal]);

    return (
        <Layout>
            <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-slate-950' : 'bg-slate-50'}`}>
                <div className="text-center">
                    <Loader2 className={`w-12 h-12 mx-auto mb-4 animate-spin ${isDarkMode ? 'text-amber-500' : 'text-amber-600'}`} />
                    <h1 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                        Opening Demo Request Form...
                    </h1>
                    <p className={`${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        Please wait while we load the form.
                    </p>
                </div>
            </div>
        </Layout>
    );
};

export default DemoRequest;
